import axios from '../axios';

class Item{
    constructor() {
        this.create = '/template/item';
        this.item_group = '/template/item_group/list';
        this.get_detail = '/template/item/:id/';
    }
    createItem(params) {
        return axios(this.create, { method: 'post', params });
    }
    getItemList(params) {
        return axios(`${this.create}/list/`, { method: 'get', params });
    }
    getItemGroupList(params) {
        return axios(this.item_group, { method: 'get', params });
    }
    getDetail(params) {
        return axios(this.get_detail, { method: 'get', params });
    }
    putDetail(params) {
        return axios(this.get_detail, { method: 'put', params });
    }
};
export default new Item();



// WEBPACK FOOTER //
// ./src/api/modules/item.js